import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import RoleStepper from "./RoleStepper";
import AccessPermission from "./AccessPermission";
import StepperController from "./StepperController";
import SuccessModal from "../../widgets/SuccessModal";
import { useRoleStore } from "../../../../store/roleStore";
import { FiChevronLeft } from "react-icons/fi";
import { PermissionsProvider } from "../../../../sevices/permissions";


export const roleStepper = ["Assign Access Permissions to User"];

const RoleLayout = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [suspendUser, setSuspendUser] = useState(false);
  const navigate = useNavigate();
  const { resetForm } = useRoleStore();

  const handleSubmit = () => {
    setSuspendUser(true);
    setTimeout(() => {
      navigate("/dashboard/settings?tab=Role+Management");
    }, 2000); // Give time for the success modal to be visible
  };

  return (
    <PermissionsProvider>
      <div className="bg-[#fff] h-100vh p-5 px-8">
        <div className="mt-5">
          <div className="flex items-center gap-4">
            <div
              onClick={() =>
                navigate("/dashboard/settings?tab=Role+Management")
              }
              className="rounded-full h-8 w-8 text-[#071827] bg-[#E5F2EA] flex items-center justify-center hover:bg-slate-300 transition-colors duration-300 cursor-pointer"
            >
              <FiChevronLeft size={23} />
            </div>
            <h1 className="text-[#071827] text-[14px] leading-[21px] font-normal">
              Role Management
            </h1>
          </div>

          <RoleStepper checkoutSteps={roleStepper} currentStep={currentStep} />

          <div>
            <AccessPermission />
          </div>

          <StepperController
            onSubmit={handleSubmit}
            currentStep={currentStep}
          />
        </div>

        {suspendUser && (
          <SuccessModal
            isOpen={suspendUser}
            onClose={() => {}}
          />
        )}
      </div>
    </PermissionsProvider>
  );
};

export default RoleLayout;
